import { Grid, Typography } from '@mui/material';
import { Answer, SubCategory } from 'features/lead/lead-questionnaire/lead-questionnaire.types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import QuestionItem from './question-item';

interface Props {
  perspective?: string;
  subCategory: SubCategory;
  answers: Answer[];

  handleRadioSelectionChange?(id: string): (value: string | number) => () => void;
}

const SubCategoryContainer: React.FC<Props> = ({ perspective, subCategory, answers, handleRadioSelectionChange }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <div>
      <div className={classes.header}>
        <Grid container={true} alignItems={'center'}>
          <Grid size={4}>
            <Typography className={classes.categoryName}>{subCategory.name}</Typography>
          </Grid>
          <Grid size={8}>
            <Grid container={true} alignItems={'center'} justifyContent={'space-around'}>
              <Grid size={1} />
              <Grid size={1}>
                <Typography className={classes.radioLabel} align={'center'}>
                  {t('never')}
                </Typography>
              </Grid>
              <Grid size={1}>
                <Typography className={classes.radioLabel} align={'center'}>
                  {t('rarely')}
                </Typography>
              </Grid>
              <Grid size={1}>
                <Typography className={classes.radioLabel} align={'center'}>
                  {t('partPart')}
                </Typography>
              </Grid>
              <Grid size={1}>
                <Typography className={classes.radioLabel} align={'center'}>
                  {t('often')}
                </Typography>
              </Grid>
              <Grid size={1}>
                <Typography className={classes.radioLabel} align={'center'}>
                  {t('almostAlways')}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
      <Grid container={true}>
        {subCategory.questions.map((question, index, questions) => (
          <Grid key={question.id} size={12}>
            <QuestionItem
              perspective={perspective}
              question={question}
              index={index}
              questions={questions}
              answers={answers}
              handleRadioSelectionChange={handleRadioSelectionChange}
              questionType={'closed'}
            />
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

const useStyles = makeStyles()((theme) => ({
  header: {
    backgroundColor: theme.palette.primary.main,
    color: '#FFF',
    padding: '8px 48px 8px 16px',
    minHeight: '60px',
    display: 'flex',
    alignItems: 'center',
  },
  categoryName: {
    fontSize: theme.typography.pxToRem(20),
  },
  radioLabel: {
    fontSize: theme.typography.pxToRem(14),
    whiteSpace: 'nowrap',
    textAlign: 'center',
  },
}));

export default SubCategoryContainer;
